exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-leaderboard .table-empty[data-v-012051cd] {\n  padding: 2rem;\n  color: #6c757d;\n  border: 1px solid #e9ecef;\n  background-color: #f8f9fa;\n  margin-bottom: 3rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-012051cd","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/LeaderBoard.vue
// module id = ZJsV
// module chunks = 1